import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Icon } from '../../Icon/Icon.es.js';
import { ModalContext } from '../Modal.Context/Modal.Context.es.js';

const ModalBack = ({ className, icon = 'ArrowLeftOutline', iconSize = 24, locale = {
    back: 'Go back'
}, ...props })=>{
    const { disableBack, onBack } = useContext(ModalContext);
    // Hide back button when back is disabled.
    if (disableBack) {
        return null;
    }
    return jsx(Button, {
        className: classNames('cb-modal-back', className),
        "data-testid": "back-button",
        label: locale.back,
        onClick: onBack,
        size: "sm",
        variant: "secondary",
        iconOnly: true,
        ...props,
        children: jsx(Icon, {
            name: icon,
            size: iconSize
        })
    });
};
ModalBack.displayName = 'Modal.Back';

export { ModalBack };
//# sourceMappingURL=Modal.Back.es.js.map
